export const ViewportBreakpoint = {
   Small: 700,
   Medium: 1250,
   Large: Infinity 
}
